<template>
  <div v-if="stations[0]">
    <div class="card box-sm comShadow" :class="{'mx-2': ava_width < 768}" style="box-shadow: 10px; border-radius: 10px">
      <div class="row">
        <div class="col-md-4 p-0 imgSZ">
          <img :src="`${$baseURL}${stations[0].image}`" class="img-fluid" alt="test"
            style="object-fit: cover; border-radius: 10px 0px 0px 10px; width: 90%; height: 23vh; margin-left: 12px" />

        </div>
        <div class="col-md-8 my-1 p-0" :class="{'mx-2': ava_width < 768}">
          <div class="d-flex align-items-center mx-2">
            <div class="col-md-10 col-10">
              <div style="font-weight: 500; font-size: 1.2rem">
                {{ stations[0].station_name }}
              </div>
            </div>
            <div class="col-md-2 col-2 d-flex justify-content-end">
              <div v-for="station in status" :key="station[0].id">
                <div v-if="station[0].id == stations[0].id">
                  <span v-if="station[1].table.siaga == []"> </span>
                  <span v-else-if="station[1].table.siaga == 'MAINTENANCE'">
                    <img :src="mtc_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 1'">
                    <img :src="s1_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 2'">
                    <img :src="s2_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 3'">
                    <img :src="s3_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'OK'">
                    <img :src="ok_i" class="statSZ" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mx-0">
              <div class="my-1 mx-2">
                <div class="info-label">Latitude</div>
                <div class="info-value">
                  {{ stations[0].latitude }}<span>&#176;</span>
                </div>
              </div>
              <div class="my-1 mx-2">
                <div class="info-label">Longitude</div>
                <div class="info-value">
                  {{ stations[0].longitude }}<span>&#176;</span>
                </div>
              </div>
            </div>

            <div class="col-md-6 mx-0">
              <div class="my-1 mx-2">
                <div class="info-label">Elevasi Permukaan</div>
                <div class="info-value">
                  {{ stations[0].elevasi }} mdpl
                </div>
              </div>
              <div class="my-1 mx-2">
                <div class="info-label">Elevasi Dasar Sumur</div>
                {{ stations[0].note.well_depth }}
                <div class="info-value">{{ stations[0].elevasi - getWellDepth(stations[0].note) }} mdpl</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="ava_width > 768" style="height: 32vh; align-items: center;">
      <!-- <div v-if="ava_width > 768" style="height: 32vh; display: flex; align-items: center; justify-content: center;"> -->

      <div v-if="!stations[1][0].chart.mix_status[0]">
        <div v-if="stations[1][0].chart.chart_sensor.flat().length == 1">
          <div v-for="card in [stations[1]]" :key="card.id">
            <div class="bg-white text-center comShadow" style="border-radius: 15px; margin-left: 12px">
              <div v-for="(item, index) in chart_f2(
                card[0].chart.mix_status,
                card[0].chart.chart_sensor,
                card[0].chart.array_act_chart_type,
                card[0].chart.chart_label,
                card[0].chart.chart_data,
                card[0].chart.array_act_icon,
                card[0].chart.array_act_symbol
              )" :key="'C' + index">
                <div>
                  <div class="d-flex row my-2 px-2">
                    <div class="col-md-6 text-white p-2  greenCard" style="border-radius: 15px">
                      <div class="mb-1 iconSZ">
                        <img :src="`${$baseURL}${item.chart_icon}`" height="85" />
                      </div>
                      <div class="fw-bold" style="font-size: 1.2rem">
                        <div>{{ item.sensor[0][0] }}</div>
                      </div>
                      <div style="font-size: 0.8rem">
                        {{ formatDate(card[0].chart.chart_date) }},
                        {{ formatTime(card[0].chart.chart_date) }}
                      </div>
                    </div>
                    <div class="col-md-6 col d-flex align-items-center justify-content-center"
                      style="color: #46dddd; border-radius: 55px">
                      <p class="fw-bold mt-2 mx-1" style="font-size: 2rem">
                        {{ item.chart_data[0].slice(-1)[0] }}
                      </p>
                      <span style="font-size: 1.5rem">{{
                        item.symbol[0][0]
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="stations[1][0].chart.chart_sensor.flat().length == 2">
          <div v-for="card in [stations[1]]" :key="card.id">
            <div class="d-flex justify-content-center align-content-around flex-wrap data align-items-center">
              <div v-for="(item, index) in chart_f2(
                card[0].chart.mix_status,
                card[0].chart.chart_sensor,
                card[0].chart.array_act_chart_type,
                card[0].chart.chart_label,
                card[0].chart.chart_data,
                card[0].chart.array_act_icon,
                card[0].chart.array_act_symbol
              )" :key="'C' + index" class="my-2">

                <div class="text-center comShadow mx-1" style="background: #fff; border-radius: 15px">
                  <div class="text-white p-2" style="
                    background: #46dddd;
                    border-radius: 15px;
                    min-width: 19vw;
                  ">
                    <div>
                      <img :src="`${$baseURL}${item.chart_icon[0]}`" height="70" />
                    </div>
                    <div class="fw-bold mt-1">
                      <div>{{ item.sensor[0][0] }}</div>
                    </div>
                    <div style="font-size: 0.9rem">
                      {{ formatDate(card[0].chart.chart_date) }},
                      {{ formatTime(card[0].chart.chart_date) }}
                    </div>
                  </div>
                  <div style="color: #46dddd">
                    <p class="p-0 m-0">
                      <span class="fw-bold mx-1" style="font-size: 2rem">{{
                        item.chart_data[0].slice(-1)[0]
                      }}</span>
                      <span style="font-size: 1rem">{{ item.symbol[0][0] }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="stations[1][0].chart.chart_sensor.flat().length == 3">
          <div v-for="card in [stations[1]]" :key="card.id">
            <div class="d-flex justify-content-center align-content-around flex-wrap data align-items-center">
              <div v-for="(item, index) in chart_f2(
                card[0].chart.mix_status,
                card[0].chart.chart_sensor,
                card[0].chart.array_act_chart_type,
                card[0].chart.chart_label,
                card[0].chart.chart_data,
                card[0].chart.array_act_icon,
                card[0].chart.array_act_symbol
              )" :key="'C' + index" class="my-2">
                <div class="text-center comShadow mx-1" style="background: #fff; border-radius: 15px">
                  <div class="text-white p-2" style="
                    background: #46dddd;
                    border-radius: 15px;
                    min-width: 12vw;
                  ">
                    <div>
                      <img :src="`${$baseURL}${item.chart_icon[0]}`" height="70" />
                    </div>
                    <div class="fw-bold mt-1">
                      <div>{{ item.sensor[0][0] }}</div>
                    </div>
                    <div style="font-size: 0.9rem">
                      {{ formatDate(card[0].chart.chart_date) }},
                      {{ formatTime(card[0].chart.chart_date) }}
                    </div>
                  </div>
                  <div style="color: #46dddd">
                    <p class="p-0 m-0">
                      <span class="fw-bold mx-1" style="font-size: 2rem">{{
                        item.chart_data[0].slice(-1)[0]
                      }}</span>
                      <span style="font-size: 1rem">{{ item.symbol[0][0] }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="stations[1][0].chart.chart_sensor.flat().length > 3">
          <div v-for="card in [stations[1]]" :key="card.id">
            <div>
              <carousel :perPage="3" :autoplay="true" :navigationEnabled="false" :loop="true" :autoplayHoverPause="true"
                :autoplayTimeout="5000" :paginationEnabled="false"
                navigationNextLabel="<i class='zmdi zmdi-chevron-right zmdi-hc-lg'></i>"
                navigationPrevLabel="<i class='zmdi zmdi-chevron-left zmdi-hc-lg'></i>">
                <slide v-for="(item, index) in chart_f2(
                  card[0].chart.mix_status,
                  card[0].chart.chart_sensor,
                  card[0].chart.array_act_chart_type,
                  card[0].chart.chart_label,
                  card[0].chart.chart_data,
                  card[0].chart.array_act_icon,
                  card[0].chart.array_act_symbol
                )" :key="'C' + index" class="my-2 d-flex justify-content-around">
                  <div class="text-center comShadow" style="background: #fff; border-radius: 15px; max-width: 12vw">
                    <div class="text-white p-2" style="
                      background: #46dddd;
                      border-radius: 15px;
                      min-width: 12vw;
                    ">
                      <div>
                        <img :src="`${$baseURL}${item.chart_icon[0]}`" height="70" />
                      </div>
                      <div class="fw-bold mt-1">
                        <div>{{ item.sensor[0][0] }}</div>
                      </div>
                      <div style="font-size: 0.9rem">
                        {{ formatDate(card[0].chart.chart_date) }},
                        {{ formatTime(card[0].chart.chart_date) }}
                      </div>
                    </div>
                    <div style="color: #46dddd">
                      <p class="p-0 m-0">
                        <span class="fw-bold mx-1" style="font-size: 2rem">{{
                          item.chart_data[0].slice(-1)[0]
                        }}</span>
                        <span style="font-size: 1rem">{{
                          item.symbol[0][0]
                        }}</span>
                      </p>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>

      <div v-if="stations[1][0].chart.mix_status[0]">
        <div v-if="stations[1][0].chart.chart_sensor.flat().length == 2">
          <div class="d-flex flex-wrap justify-content-around">
            <div v-for="(sensorData, index) in stations[1][0].chart.chart_data" :key="index">
              <div class="my-2">
                <div class="text-center comShadow mx-1" style="background: #fff; border-radius: 15px; min-width: 19vw;">
                  <div class="text-white p-2" style="background: #46dddd; border-radius: 15px;">
                    <div>
                      <img :src="`${$baseURL}${stations[1][0].chart.array_act_icon[0][index][0]}`" height="70" />
                    </div>
                    <div class="fw-bold mt-1">
                      <div>{{ stations[1][0].chart.chart_sensor[0][index][0] }}</div>
                    </div>
                    <div style="font-size: 0.9rem">
                      {{ formatDate(stations[1][0].chart.chart_date) }}, {{ formatTime(stations[1][0].chart.chart_date)
                      }}
                    </div>
                  </div>
                  <div style="color: #46dddd">
                    <p class="p-0 m-0">
                      <span class="fw-bold mx-1" style="font-size: 2rem">{{ getLastData(sensorData[0]) }}</span>
                      <span style="font-size: 1rem">{{ stations[1][0].chart.array_act_symbol[0][index][0] }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="stations[1][0].chart.chart_sensor.flat().length == 3">
          <div class="d-flex flex-wrap justify-content-around">
            <div v-for="(sensorData, index) in stations[1][0].chart.chart_data" :key="index">
              <div class="my-2">
                <div class="text-center comShadow mx-1" style="background: #fff; border-radius: 15px;">
                  <div class="text-white p-2" style="background: #46dddd; border-radius: 15px; min-width: 12vw;">
                    <div>
                      <img :src="`${$baseURL}${stations[1][0].chart.array_act_icon[0][index][0]}`" height="70" />
                    </div>
                    <div class="fw-bold mt-1">
                      <div>{{ stations[1][0].chart.chart_sensor[0][index][0] }}</div>
                    </div>
                    <div style="font-size: 0.9rem">
                      {{ formatDate(stations[1][0].chart.chart_date) }}, {{ formatTime(stations[1][0].chart.chart_date)
                      }}
                    </div>
                  </div>
                  <div style="color: #46dddd">
                    <p class="p-0 m-0">
                      <span class="fw-bold mx-1" style="font-size: 2rem">{{ getLastData(sensorData[0]) }}</span>
                      <span style="font-size: 1rem">{{ stations[1][0].chart.array_act_symbol[0][index][0] }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="stations[1][0].chart.chart_sensor.flat().length > 3">
          <div v-for="card in [stations[1]]" :key="card.id">
            <div>
              <carousel :perPage="3" :autoplay="true" :navigationEnabled="false" :loop="true" :autoplayHoverPause="true"
                :autoplayTimeout="5000" :paginationEnabled="false"
                navigationNextLabel="<i class='zmdi zmdi-chevron-right zmdi-hc-lg'></i>"
                navigationPrevLabel="<i class='zmdi zmdi-chevron-left zmdi-hc-lg'></i>">
                <slide v-for="(sensorData, index) in stations[1][0].chart.chart_data" :key="index"
                  class="my-2 d-flex justify-content-around">
                  <div class="text-center comShadow" style="background: #fff; border-radius: 15px; max-width: 12vw">
                    <div class="text-white p-2" style="
                      background: #46dddd;
                      border-radius: 15px;
                      min-width: 12vw;
                    ">
                      <div>
                        <img :src="`${$baseURL}${stations[1][0].chart.array_act_icon[0][index][0]}`" height="70" />
                      </div>
                      <div class="fw-bold mt-1">
                        <div>{{ stations[1][0].chart.chart_sensor[0][index][0] }}</div>
                      </div>
                      <div style="font-size: 0.9rem">
                        {{ formatDate(stations[1][0].chart.chart_date) }}, {{
                          formatTime(stations[1][0].chart.chart_date)
                        }}
                      </div>
                    </div>
                    <div style="color: #46dddd">
                      <p class="p-0 m-0">
                        <span class="fw-bold mx-1" style="font-size: 2rem">{{ getLastData(sensorData[0]) }}</span>
                        <span style="font-size: 1rem">{{ stations[1][0].chart.array_act_symbol[0][index][0] }}</span>
                      </p>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CHART -->
    <div :class="{'mx-2': ava_width < 768}" >
      <div v-for="(card, index) in stations[1]" :key="index" >
        <div v-for="(item, index) in chart_f2(
          card.chart.mix_status,
          card.chart.chart_sensor,
          card.chart.array_act_chart_type,
          card.chart.chart_label,
          card.chart.chart_data,
          card.chart.array_act_icon,
          card.chart.array_act_symbol
        )" :key="index" >
          <div class="comShadow" style="border-radius: 15px;">
            <div v-if="item.chart_type[0] == 'BarChart' || item.chart_type[0] == 'LineChart'
            " class="box-sm border rounded mx-auto bg-white mb-2" style="border-radius: 15px">
              <div class="rounded">
                <div>
                  <div class="px-2 py-1 ">
                    Visualisasi {{ item.sensor[0][0] }} (mdpl)
                  </div>
                  <Chart style="height: 32vh;" class="p-0 pr-0 pt-0 pb-0" :label="label" 
                  :chart-data="[
                    debitData.map(value => (stations[0].elevasi - value).toFixed(2)), // Original data
                    debitData.map(() => stations[0].elevasi) // Flat line
                  ]" 
                  :title="`${item.sensor[0][0]} (${item.symbol[0][0]})`" :selectedIndex="reversedSelectedIndex"
                  :elev="stations[0].elevasi - getWellDepth(stations[0].note)" is="LineChartFilteredZero"></Chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import LineChartFiltered from "@/components/Chart/LineChartFiltered";
import LineChartFilteredZero from "@/components/Chart/LineChartFilteredZero";

import mtc_i from "@/assets/icons/map/mtc.svg";
import ok_i from "@/assets/icons/map/ok.svg";
import s1_i from "@/assets/icons/map/s1.svg";
import s2_i from "@/assets/icons/map/s2.svg";
import s3_i from "@/assets/icons/map/s3.svg";

export default {
  name: "Slider",
  props: ["stations", "status", "ava_width", "debitData", "label", "selectedIndex"],
  components: {
    // LineChartFiltered,
    LineChartFilteredZero,

  },
  data() {
    return {
      mtc_i,
      ok_i,
      s1_i,
      s2_i,
      s3_i,
      total_s: null,
      jsonData: null,
    };
  },
  // watch: {
  //   selectedIndex(newIndex) {
  //     console.log("selectedIndex:", newIndex);
  //   }
  // },
  computed: {
    reversedSelectedIndex() {
      return this.selectedIndex !== null ? this.debitData.length - 1 - this.selectedIndex : null;
    }
  },
  methods: {
    getWellDepth(note) {
      const match = note.match(/well_depth:\s*([\d.]+)/); // Match decimal numbers
      return match ? parseFloat(match[1]) : 0; // Convert to float
    },
    getLastData(sensorData) {
      return sensorData[sensorData.length - 1];
    },
    formatDate(date) {
      var monthShortNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];
      var d = new Date(date),
        year = d.getFullYear(),
        month = "" + d.getMonth(),
        day = "" + d.getDate();

      if (day.length < 2) day = "0" + day;
      return [day, monthShortNames[month], year].join(" ");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes(),
        second = d.getSeconds();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;
      if (second.length < 2) second = "0" + second;

      return [hour, minute].join(":");
    },
    formatPrevDate(date) {
      var monthShortNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];
      var days = -1;

      var d = new Date(date);

      var d_1 = new Date(d.getTime() + days * 24 * 60 * 60 * 1000),
        day_1 = "" + d_1.getDate(),
        month_1 = "" + d_1.getMonth(),
        year_1 = d_1.getFullYear();

      if (day_1.length < 2) day_1 = "0" + day_1;

      return [day_1, monthShortNames[month_1], year_1].join(" ");
    },

    chart_f2(a, b, c, d, e, g, h) {
      return a.map((card, i) => {
        return {
          mix: card,
          sensor: b[i],
          chart_type: c[i],
          chart_label: d[i],
          chart_data: e[i],

          chart_icon: g[i],
          symbol: h[i],
        };
      });
    },

  },

  created() {
    this.userJSONParse();
    var x = this.stations[1][0].chart.chart_sensor;
    this.total_s = x.flat().length;
  },

};
</script>

<style scoped>
.data-font {
  font-size: 2rem;
}

.symbol-font {
  font-size: 1.2rem;
}

.title-font {
  font-size: 1.1rem;
}

.root.padding {
  padding: 0;
}

.flex {
  display: flex;
  /* gap: 0.5rem; */
  flex-wrap: wrap;
}

.steps-wrapper {
  background-color: #232323;
}

.img-awlr {
  height: 150px;
}

@media only screen and (max-width: 768px) {
  .flex>div {
    flex: 100%;
  }
}

ul {
  list-style: none;
  display: table;
}

li {
  display: table-row;
}

b {
  display: table-cell;
  padding-right: 1em;
}

.statSZ {
  height: 22px;
  margin-right: 10px;
}

.comShadow {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

.iconSZ img {
  resize: both;
  height: 12vh;
  max-height: 12vh;
}

.img-normal {
  height: 160px;
  width: 190px;
}

/* Add your desired styles for the label and value containers */
.info-label {
  font-weight: 500;
  font-size: 1rem;
}

.info-value {
  margin-left: 10px;
  font-size: 1rem;
}

/* Dummy element style to hide if needed */
.info-dummy {
  margin-left: 10px;
  color: rgba(255, 255, 255, 0);
  font-size: 1rem;
}

.imgSZ img {
  resize: both;
  height: 180px;
  width: 190px;
}

@media (max-width: 768px) {
  .imgSZ {
    height: 170px;
    /* You can adjust the height as needed */
  }

  .info-dummy {
    display: none;
  }
}
</style>